/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ContactMemoFromJSON, ContactMemoToJSON } from './ContactMemo';
export function CreateContactMemoResponseDataFromJSON(json) {
    return CreateContactMemoResponseDataFromJSONTyped(json, false);
}
export function CreateContactMemoResponseDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        contactMemo: !exists(json, 'contact_memo') ? undefined : ContactMemoFromJSON(json['contact_memo'])
    };
}
export function CreateContactMemoResponseDataToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        contact_memo: ContactMemoToJSON(value.contactMemo)
    };
}
